export enum FieldType {
  Text = 'text',
  Checkbox = 'checkbox',
  Radio = 'radio'
}

export type RequestFieldValue = string

export interface TextSettings {
  isMandatory: boolean
  labelText: string | null
  hideLabel: boolean
  placeholderText: string | null
  helperText: string | null
  tooltipText: string | null
  isTextArea: boolean
  characterLimitMin: number | null
  characterLimitMax: number | null
}

export interface CheckboxOption {
  uuid: string
  name: string
}

export interface CheckboxSettings {
  isMandatory: boolean
  labelText: string | null
  hideLabel: boolean
  options: CheckboxOption[]
}

export interface RadioOption {
  uuid: string
  name: string
}

export interface RadioSettings {
  isMandatory: boolean
  labelText: string | null
  hideLabel: boolean
  options: RadioOption[]
}

export type TypedSettings =
  | {
      field_type: FieldType.Text // eslint-disable-line camelcase
      type_settings: TextSettings // eslint-disable-line camelcase
    }
  | {
      field_type: FieldType.Checkbox // eslint-disable-line camelcase
      type_settings: CheckboxSettings // eslint-disable-line camelcase
    }
  | {
      field_type: FieldType.Radio // eslint-disable-line camelcase
      type_settings: RadioSettings // eslint-disable-line camelcase
    }

export type FieldDefinition = {
  id: number
  version_id: number // eslint-disable-line camelcase
  visibility: string
} & TypedSettings
